import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiCardActions = {
    styleOverrides: {
        root: {
            padding: 0,
        },
        // This class is on by default
        spacing: {
            padding: '8px',
        },
    },
} satisfies Components<Theme>['MuiCardActions'];
